import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "antd/lib/message/style";
import _message from "antd/lib/message";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import axios from 'axios';
import { ERROR_MESSAGE, SESSIONSTORAGE_KEYS, SUCCESS_MESSAGE } from '@constants/index';
var HTTPERROR;

(function (HTTPERROR) {
  HTTPERROR[HTTPERROR["LOGICERROR"] = 0] = "LOGICERROR";
  HTTPERROR[HTTPERROR["TIMEOUTERROR"] = 1] = "TIMEOUTERROR";
  HTTPERROR[HTTPERROR["NETWORKERROR"] = 2] = "NETWORKERROR";
})(HTTPERROR || (HTTPERROR = {}));

var TOKENERROR = [401, 402, 403];
var DEFAULTCONFIG = {
  baseURL: process.env.BASEURL
};
var http = {};
var methods = ['get', 'post', 'put', 'delete'];
var authTimer = null;

var isSuccess = res => res.errCode === 0;

var resFormat = res => res.response || res.data || {};

methods.forEach(v => {
  http[v] = (url, data, baseUrl) => {
    var token = JSON.parse(sessionStorage.getItem(SESSIONSTORAGE_KEYS.USERINFO) || '{}')['token'];
    var axiosConfig = {
      method: v,
      url,
      baseURL: baseUrl || DEFAULTCONFIG.baseURL,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    var instance = axios.create(DEFAULTCONFIG); // Add a request interceptor

    instance.interceptors.request.use(cfg => {
      cfg.params = _objectSpread(_objectSpread({}, cfg.params), {}, {
        ts: Date.now() / 1000
      });
      return cfg;
    }, error => Promise.reject(error)); // Add a response interceptor

    instance.interceptors.response.use(response => {
      return resFormat(response);
    }, error => {
      var _error$response, _error$response2, _error$response3;

      if (TOKENERROR.includes(error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status)) {
        _message.destroy();

        _message.error('Authentication failure, Please relogin!');

        clearTimeout(authTimer);
        authTimer = setTimeout(() => {
          sessionStorage.removeItem(SESSIONSTORAGE_KEYS.USERINFO);
          location.replace(process.env.MANAGERURL);
        }, 300);
        return;
      }

      return Promise.reject({
        msg: (error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.statusText) || (error === null || error === void 0 ? void 0 : error.message) || 'network error',
        type: /^timeout of/.test(error.message) ? HTTPERROR[HTTPERROR.TIMEOUTERROR] : HTTPERROR[HTTPERROR.NETWORKERROR],
        config: error.config,
        data: error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.data
      });
    });

    if (v === 'get' || v === 'delete') {
      axiosConfig.params = data;
    } else {
      axiosConfig.data = data;
    }

    axiosConfig.startTime = new Date();
    return instance.request(axiosConfig).then(res => {
      if (v !== 'get') _message.success(SUCCESS_MESSAGE);
      return res;
    }).catch(err => {
      var _err$data;

      if ((_err$data = err.data) === null || _err$data === void 0 ? void 0 : _err$data.error) {
        var _err$data2;

        _message.error((_err$data2 = err.data) === null || _err$data2 === void 0 ? void 0 : _err$data2.error);
      } else {
        _message.error(ERROR_MESSAGE);
      }

      console.error(err.response || err.msg || err.stack || 'unknown error');
      return Promise.reject(axiosConfig.url.includes('autoScript.set') ? {
        err
      } : {
        err,
        stack: err.msg || err.stack || ''
      });
    });
  };
});
export default http;